import * as THREE from 'three';
import {
  CAMERA_DISTANCE,
  CAMERA_HEIGHT,
  CAMERA_LAG,
  CAMERA_LOOK_AHEAD,
} from '../config';

export class CameraRig {
  private readonly desiredPosition = new THREE.Vector3();
  private readonly lookTarget = new THREE.Vector3();

  // 屏幕震动
  private shakeIntensity = 0;
  private shakeDuration = 0;
  private shakeTimer = 0;

  constructor(
    private readonly camera: THREE.PerspectiveCamera,
  ) {}

  snapTo(target: THREE.Vector3, targetRotationY: number): void {
    const behind = new THREE.Vector3(
      -Math.sin(targetRotationY) * CAMERA_DISTANCE,
      CAMERA_HEIGHT,
      -Math.cos(targetRotationY) * CAMERA_DISTANCE,
    );
    this.desiredPosition.copy(target).add(behind);
    this.camera.position.copy(this.desiredPosition);
    this.lookTarget.copy(target);
    this.lookTarget.add(new THREE.Vector3(
      Math.sin(targetRotationY) * CAMERA_LOOK_AHEAD,
      1,
      Math.cos(targetRotationY) * CAMERA_LOOK_AHEAD,
    ));
    this.camera.lookAt(this.lookTarget);
  }

  update(delta: number, target: THREE.Vector3, targetRotationY: number): void {
    const behind = new THREE.Vector3(
      -Math.sin(targetRotationY) * CAMERA_DISTANCE,
      CAMERA_HEIGHT,
      -Math.cos(targetRotationY) * CAMERA_DISTANCE,
    );
    this.desiredPosition.copy(target).add(behind);

    const factor = 1 - Math.exp(-delta / Math.max(0.001, CAMERA_LAG));
    this.camera.position.lerp(this.desiredPosition, factor);

    this.lookTarget.copy(target);
    this.lookTarget.add(new THREE.Vector3(
      Math.sin(targetRotationY) * CAMERA_LOOK_AHEAD,
      1.5,
      Math.cos(targetRotationY) * CAMERA_LOOK_AHEAD,
    ));

    // 屏幕震动
    if (this.shakeTimer > 0) {
      this.shakeTimer -= delta;
      const shakeX = (Math.random() - 0.5) * 2 * this.shakeIntensity;
      const shakeY = (Math.random() - 0.5) * 2 * this.shakeIntensity;
      this.camera.position.x += shakeX;
      this.camera.position.y += shakeY;
    }

    this.camera.lookAt(this.lookTarget);
  }

  shake(intensity: number, duration: number): void {
    this.shakeIntensity = Math.max(this.shakeIntensity, intensity);
    this.shakeDuration = Math.max(this.shakeDuration, duration);
    this.shakeTimer = this.shakeDuration;
  }
}
